import DownloadRoundedIcon from "@mui/icons-material/DownloadRounded"
import { ReactElement, useState } from "react"

import AppLoadingButton from "./appLoadingButton"
import useDownload from "../../services/middleware/hooks/useDownload"

interface IDownloadButtonProps {
    urlOrFetcher: string | (() => Promise<void>)
    sensitiveDataWarning?: boolean
}

/**
 * Button which allows user to download data either from a provided URL, or a provided fetcher.
 * @example
 * <DownloadButton urlOrFetcher={"http://example.com/file.txt"} />
 */
const DownloadButton = ({
    urlOrFetcher,
    sensitiveDataWarning = false,
}: IDownloadButtonProps): ReactElement => {
    const { downloadAttachment, isLoading } = useDownload(sensitiveDataWarning)
    const [fetchingURL, setFetchingURL] = useState(false)
    const downloadFunction =
        typeof urlOrFetcher === "string"
            ? () => downloadAttachment(urlOrFetcher)
            : () => {
                  setFetchingURL(true)
                  urlOrFetcher().then(() => {
                      setFetchingURL(false)
                  })
              }

    return (
        <AppLoadingButton
            endIcon={<DownloadRoundedIcon />}
            loading={isLoading || fetchingURL}
            loadingPosition="end"
            onClick={downloadFunction}
        >
            Download
        </AppLoadingButton>
    )
}

DownloadButton.defaultProps = {
    sensitiveDataWarning: false,
}

export default DownloadButton
